import { useMutation, ApolloError, gql } from '@apollo/client';

type UseForgotPasswordHook = () => IUseForgotPasswordHookResult;

export interface IUseForgotPasswordHookResult {
  result: {
    data?: { resetPassword: boolean } | null;
    error?: ApolloError;
    loading: boolean;
    called: boolean;
  };
  resetPassword: (
    password: string,
    token: string,
  ) => void;
}

const useForgotPassword: UseForgotPasswordHook = () => {
  const FORGOT_PASSWORD = gql`
    mutation ($request: PasswordResetInputType!) {
      resetPassword(item: $request)
    }
  `;

  const [saveFunc, {
    data, error, loading, called,
  }] = useMutation<{resetPassword: boolean}>(
    FORGOT_PASSWORD,
  );

  return {
    result: {
      data, error, loading, called,
    },
    resetPassword: (
      password: string,
      token: string,
    ) => saveFunc({
      variables: {
        request: {
          password,
          token,
        },
      },
    }),
  };
};

export default useForgotPassword;
